import {applyooConfig} from "../js/applyooConfig";
import {utils_ui} from "./utils_ui";

export class utils_log {
    constructor() {

    }
    static init() {
        window.onerror = function myErrorHandler(errorMsg, url, lineNumber) {
            if (applyooConfig?.IS_DEBUG_MODE == 1) {
                alert("Error occured: " + errorMsg);//or any message
            }

            utils_ui.setLocalStorageItem("LastSessionErrorDT",new Date(),false)

            return false;
        }
    }
    //static isWriteToConsole:any = applyooConfig?.isDebugMode;

    static writeToLog(prmObj:any) {
        if (applyooConfig?.IS_DEBUG_MODE == 1) {
            console.log(new Date(), prmObj);
        }
    }

    static writeObjectToLog(prmTitle:any, prmObj:any, prmSubObj?:any) {
        if (applyooConfig?.IS_DEBUG_MODE == 1) {
            console.log(new Date(), prmTitle, prmObj, prmSubObj);
        }
    }


}